import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { EntityType, WashDto } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  wash: WashDto;
}

export default function GeneralHistoryTabContent({ wash }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <GeneralHistoryPaginatedList
          defaultValues={{
            subjectEntityType: EntityType.Wash,
            subjectEntityId: wash.id,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
